import React from 'react';
import linkifyHtml from 'linkifyjs/html';
import parse from 'html-react-parser';

export interface ILinkParserProps {
  className?: string;
  openExternal?: boolean;
  children: string;
}

export default function LinkParser({
  className = 'auto-generated',
  openExternal = true,
  children,
}: ILinkParserProps): JSX.Element {
  if (!children?.replace) {
    // children is not a string
    return null;
  }

  // linkifyjs will parse all html tags - but we don't want users to be able to add their own tags
  // or accidentally add invalid (unclosed) html. The easiest way is to just replace the open/close characters.
  const sanitizedChildren = children.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return (
    <>
      {parse(
        linkifyHtml(sanitizedChildren, {
          className,
          target: {
            url: openExternal ? '_blank' : '_self',
          },
        })
      )}
    </>
  );
}
